import { Profile } from '@/types'
import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from './queryKeys'
import { retrieve } from './views'

export const useProfile = (options = {}) => {
  return useQuery({
    ...options,
    queryKey: QueryKeys.me.key,
    queryFn: retrieve,
    refetchOnWindowFocus: false,
    refetchOnMount(q) {
      return q.state.dataUpdateCount == 0
    },
    retry: 3,
  })
}
